"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torre-de-picenardi": {
    "e47f70f5": [{
      "hkey": "863ffd0c",
      "slug": "breda-guazzona",
      "name": "Breda Guazzona",
      "primary": true,
      "skipSearch": false
    }],
    "breda-guazzoni": [{
      "hkey": "863ffd0c",
      "slug": "breda-guazzona",
      "name": "Breda Guazzona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7d889050": [{
      "hkey": "2dc13c35",
      "slug": "ca-nove-de-biazzi",
      "name": "Ca' Nove de' Biazzi",
      "primary": true,
      "skipSearch": false
    }],
    "canove-de-biazzi": [{
      "hkey": "2dc13c35",
      "slug": "ca-nove-de-biazzi",
      "name": "Ca' Nove de' Biazzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "914b3ea8": [{
      "hkey": "73b86783",
      "slug": "torre-de-picenardi",
      "name": "Torre de' Picenardi",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-san-maurizio": [{
      "hkey": "73b86783",
      "slug": "torre-de-picenardi",
      "name": "Torre de' Picenardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;